/**
 * Returns `element.ownerDocument || window.document`.
 */
function getDocument(element) {
  return element ? element.ownerDocument || element : window.document;
}

export { getDocument };
